export default __webpack_public_path__ + "static/media/set-reminder.b6e842ae.svg";